export default [
   {"const": "Malaysian", "title": "Malaysian"},
   {"const": "Indonesian", "title": "Indonesian"},
   {"const": "Singaporean", "title": "Singaporean"},
   {"const": "Thai People", "title": "Thai People"},
   {"const": "Chinese", "title": "Chinese"},
   {"const": "Korean", "title": "Korean"},
   {"const": "Japanese", "title": "Japanese"},
   {"const": "British", "title": "British"},
   {"const": "American", "title": "American"},
   {"const": "German", "title": "Germany"},
]
